import { render, staticRenderFns } from "./home-payment-chart.vue?vue&type=template&id=2510def8&"
import script from "./home-payment-chart.vue?vue&type=script&lang=js&"
export * from "./home-payment-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports